/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class DimensionRuleMapping {
    getFixupPrototypeFunction() { return DimensionRuleMapping.fixupPrototype; }

    static newInstance(model: Partial<DimensionRuleMapping>): DimensionRuleMapping {
        let obj = Object.assign(new DimensionRuleMapping(), model);
        DimensionRuleMapping.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<DimensionRuleMapping>): DimensionRuleMapping {
        if (!model) return null;
        return DimensionRuleMapping.newInstance(<DimensionRuleMapping> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: DimensionRuleMapping) {
        if (!obj) return;

        models.DimensionRuleMapping.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: DimensionRuleMapping): boolean {
        Object.setPrototypeOf(obj, DimensionRuleMapping.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    /**
     * Dimension ID
     */
    dimension_id: string;

    /**
     * Grouping Rule IDs that belong to this dimension
     */
    grouping_rule_ids: Array<string>;

}
